var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleRightDuotoneActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10703_6970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 10.5418C18.9134 10.5418 20.3125 9.11624 20.3125 7.35779C20.3125 5.59934 18.9134 4.17383 17.1875 4.17383C15.4616 4.17383 14.0625 5.59934 14.0625 7.35779C14.0625 9.11624 15.4616 10.5418 17.1875 10.5418Z",
    fill: "#05B14E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 0.990234H7.8125C4.36072 0.990234 1.5625 3.84125 1.5625 7.35816C1.5625 10.8751 4.36072 13.7261 7.8125 13.7261H17.1875C20.6393 13.7261 23.4375 10.8751 23.4375 7.35816C23.4375 3.84125 20.6393 0.990234 17.1875 0.990234Z",
    stroke: "#05B14E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 10.5418C18.9134 10.5418 20.3125 9.11624 20.3125 7.35779C20.3125 5.59934 18.9134 4.17383 17.1875 4.17383C15.4616 4.17383 14.0625 5.59934 14.0625 7.35779C14.0625 9.11624 15.4616 10.5418 17.1875 10.5418Z",
    stroke: "#05B14E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10703_6970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleRightDuotoneActiveIcon);
export default __webpack_public_path__ + "static/media/toggle-right-duotone-active-icon.5cdaedafb6c039a10c8e812808107637.svg";
export { ForwardRef as ReactComponent };